<sui-select
  [ngModel]="currentLanguage"
  (ngModelChange)="handleLanguageChange($event)"
  (click)="$event.stopPropagation()"
>
  <sui-select-option
    *ngFor="let language of languages"
    [value]="language.code"
    [label]="getFlagEmoji(language.code) + ' ' + language.name"
    >{{ getFlagEmoji(language.code) }} {{ language.name }}</sui-select-option
  >
</sui-select>
